import {post} from './http'
const baseUrl = '/api/admin/kmc/channel'

// 获取渠道内容列表
export const getOrderList = v => post(`${baseUrl}/getOrderList`, v.data, v.success, v.error)
